import { invokeApi } from "../../utils/invokeApi/invokeApi";

export const candidates_list_api = async (
  id,
  page = 0,
  limit = 50,
  search = "",
  response = "pending",
  latest
) => {
  const requestObj = {
    path: `api/jobs/job_application_list/${id}?page=${page}&limit=${limit}&search=${search}&application_response=${response}&latest=${latest}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const ideal_candidate_list = async (
  id,
  page = 0,
  limit = 50,
  search = "",
  response = "pending",
  latest
) => {
  const requestObj = {
    path: `api/jobs/top_rated_applications/${id}?page=${page}&limit=${limit}&search=${search}&application_response=${response}&latest=${latest}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const change_job_applicant_status = async (data) => {
  const requestObj = {
    path: `api/jobs/job_application_response`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const send_email_to_applicant = async (data) => {
  const requestObj = {
    path: `api/jobs/send_manual_mail`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const send_email_to_all_applicant = async (data) => {
  const requestObj = {
    path: `api/jobs/send_mail_to_all`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const update_application_read_unread_status = async (data, id) => {
  const requestObj = {
    path: `api/jobs/update_application_read_unread_status/${id}`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};
